import React from 'react'
import { getStatusOptions } from '@paintscout/util/builder'
import { StatusDot } from '@paintscout/ui'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import type { QuoteStatus, QuoteTag } from 'paintscout'
import { QuoteTagTooltip, QuoteTagIcons } from '../QuoteTagIcons'

export interface StatusColumnProps {
  status: string
  dense?: boolean
  error?: boolean | string
  archived?: boolean
  tags?: QuoteTag[]
}

function StatusColumn({ status: statusValue, dense, error, archived, tags }: StatusColumnProps) {
  const isError = typeof error === 'string' ? error.toLowerCase() === 'true' : error
  const statusOptions = getStatusOptions({ all: true })
  let status = find(statusOptions, { value: statusValue })

  if (!statusValue) {
    return null
  }

  if (!status) {
    status = {
      value: statusValue,
      label: capitalize(statusValue)
    }
  }

  return isEmpty(tags) ? (
    <>
      <StatusDot size={9} status={status.value as QuoteStatus} error={isError} archived={archived} dense={dense}>
        {dense ? '' : ` ${status.label}`}
      </StatusDot>
    </>
  ) : (
    <QuoteTagTooltip tags={tags} tooltipProps={{ placement: 'right' }}>
      <>
        <StatusDot size={9} status={status.value as QuoteStatus} error={isError} archived={archived}>
          {!dense ? ` ${status.label}` : ''}
        </StatusDot>
        {!isEmpty(tags) && !dense && <QuoteTagIcons tags={tags} />}
      </>
    </QuoteTagTooltip>
  )
}

function capitalize(text: string) {
  return text.slice(0, 1).toUpperCase() + text.slice(1)
}

export default StatusColumn
